import base from 'components/base'
import componentInit from 'components/componentInit'
import main from 'main'
import $ from 'jquery'

class dialog extends base
{
  elements = {
    dialog: null,
    openButton: null,
    closeButton: null,
    siteBody: null
  }

  scrollPoint = {}

  constructor(dialogElement, openButtonElement)
  {
    super()

    this.elements.dialog = $(dialogElement).get(0)

    let closeButton = $(this.elements.dialog).children('button.close').get(0)
    if(closeButton)
      this.elements.closeButton = closeButton
    else
      this.elements.closeButton = $('<button class="close"><div class="icon"></div><div class="title">'+ main.framework.dict.default.close +'</div></button>')
        .prependTo(this.elements.dialog)
        .get(0)

    this.elements.openButton = $(openButtonElement).get(0)
    this.elements.siteBody = $('body').get(0)

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.openButton).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.open()
    })

    $(this.elements.closeButton).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.close()
    })
  }

  open()
  {
    this.scrollPoint = {
      top: $(window).scrollTop(),
      left: $(window).scrollLeft()
    }

    //$(this.elements.dialog).css('top', this.scrollPoint.top)
    window.scrollTo(0, 0)
    $(this.elements.siteBody).toggleClass('dialog-open', true)
  }

  close(params)
  {
    $(this.elements.siteBody).toggleClass('dialog-open', false)
    window.scrollTo(this.scrollPoint.left, this.scrollPoint.top)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let dialogElement = $(parentElement).find('.dialog').get(0)
  let openButtonElement = $(parentElement).find('.open-dialog').get(0)
  new dialog(dialogElement, openButtonElement)
}

export default dialog




// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/dialog.js